<template>
  <div class="grid">
    <div class="col-3 p-3 border-right">
      <Button
        v-if="!isEditing"
        label="Editer mon profil"
        icon="pi pi-pencil"
        class="p-button-primary w-full mb-3"
        @click="startEditing"
      />
      <Button
        v-if="isEditing"
        label="Enregistrer"
        icon="pi pi-check"
        class="p-button-success w-full mb-3"
        @click="saveProfile"
      />
    </div>

    <div class="col-9 p-4">
      <h3 class="text-primary">Mon Profil</h3>
      
      <div class="grid">
        <div class="col-5 field-spacing">
          <label for="nom" class="block text-base font-bold text-blue-600">Nom</label>
          <InputText
            id="nom"
            v-model="profile.nom"
            class="w-full bg-light mt-2"
            :disabled="!isEditing"
          />
        </div>
        
        <div class="col-5 field-spacing ml-3">
          <label for="prenom" class="block text-base font-bold text-blue-600">Prénom(s)</label>
          <InputText
            id="prenom"
            v-model="profile.prenom"
            class="w-full bg-light mt-2"
            :disabled="!isEditing"
          />
        </div>

        <div class="col-5 field-spacing">
          <label for="genre" class="block text-base font-bold text-blue-600">Genre</label>
          <Dropdown
            id="genre"
            v-model="profile.genre"
            :options="genders"
            optionLabel="label"
            class="w-full bg-light mt-2"
            :disabled="!isEditing"
          />
        </div>

        <div class="col-5 field-spacing ml-3">
          <label for="poste" class="block text-base font-bold text-blue-600">Poste</label>
          <InputText
            id="poste"
            v-model="profile.poste"
            class="w-full bg-light mt-2"
            :disabled="!isEditing"
          />
        </div>
        <div class="col-5 field-spacing">
          <label for="email" class="block text-base font-bold text-blue-600">Email</label>
          <InputText
            id="email"
            v-model="profile.email"
            class="w-full bg-light mt-2"
            :disabled="!isEditing"
          />
        </div>

        <div class="col-5 field-spacing ml-3">
          <label for="telephone" class="block text-base font-bold text-blue-600">
            Numéro de téléphone
          </label>
          <InputText
            id="telephone"
            v-model="profile.telephone"
            class="w-full bg-light mt-2"
            :disabled="!isEditing"
          />
        </div>
        <div class="col-5 field-spacing">
          <label for="codePostal" class="block text-base font-bold text-blue-600">Code postal</label>
          <InputText
            id="codePostal"
            v-model="profile.codePostal"
            class="w-full bg-light mt-2"
            :disabled="!isEditing"
          />
        </div>

        <div class="col-5 field-spacing ml-3">
          <label for="rue" class="block text-base font-bold text-blue-600">Rue</label>
          <InputText
            id="rue"
            v-model="profile.rue"
            class="w-full bg-light mt-2"
            :disabled="!isEditing"
          />
        </div>
        <div class="col-5 field-spacing">
          <label for="ville" class="block text-base font-bold text-blue-600">
            Ville de résidence
          </label>
          <InputText
            id="ville"
            v-model="profile.ville"
            class="w-full bg-light mt-2"
            :disabled="!isEditing"
          />
        </div>

        <div class="col-5 field-spacing ml-3">
          <label for="quartier" class="block text-base font-bold text-blue-600">Quartier</label>
          <InputText
            id="quartier"
            v-model="profile.quartier"
            class="w-full bg-light mt-2"
            :disabled="!isEditing"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { ref } from "vue";
import { InputText } from "primevue/inputtext";
import { Button } from "primevue/button";
import { Dropdown } from "primevue/dropdown";

export default {
  name: "ProfilPage",
  components: {
    InputText,
    Button,
    Dropdown,
  },
  setup() {
    const profile = ref({
      nom: "",
      prenom: "",
      genre: null,
      poste: "",
      email: "@gmail.com",
      telephone: "",
      codePostal: "",
      rue: "",
      ville: "",
      quartier: "",
    });

    const isEditing = ref(false);

    const genders = ref([
      { label: "Homme", value: "homme" },
      { label: "Femme", value: "femme" },
      { label: "Autre", value: "autre" },
    ]);

    const startEditing = () => {
      isEditing.value = true;
    };

    const saveProfile = () => {
      isEditing.value = false;
      console.log("Informations enregistrées :", profile.value);
    };

    return {
      profile,
      isEditing,
      genders,
      startEditing,
      saveProfile,
    };
  },
};
</script>

<style lang="scss" src="./profil-page.scss" scoped />
